import Dynamsoft from 'dynamsoft-javascript-barcode';
Dynamsoft.BarcodeReader.engineResourcePath = 'https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@7.4.0-v1/dist/';
// Please visit https://www.dynamsoft.com/CustomerPortal/Portal/TrialLicense.aspx to get a trial license
Dynamsoft.BarcodeReader.productKeys =
  't0068NQAAAKC5u4FkmyfYDcbxaPuiR+w8mMFmxeO0pIv19Q9YA3X+PzZzN7wxc11HoZFvutYdpLYuOlnD/Wb68jyTWoyPYBk=';
// Dynamsoft.BarcodeReader._bUseFullFeature = true; // Control of loading min wasm or full wasm.
export default Dynamsoft;
